import { Alert, Badge, Center, Loader } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import { ApiError } from "../api/client";

export const STATUS_COLORS: Record<string, string> = {
  RUNNING: "green",
  IDLE: "yellow",
  SETUP: "blue",
  DOWN: "red",
  FAULT: "red",
  STOPPED: "orange",
  OFFLINE: "gray",
  NO_DATA: "gray",
  UNKNOWN: "grape",
};

export function StatusBadge({ status }: { status: string }) {
  return (
    <Badge color={STATUS_COLORS[status] ?? "grape"} variant="filled" radius="sm">
      {status.replace("_", " ")}
    </Badge>
  );
}

export function Loading() {
  return (
    <Center p="xl">
      <Loader />
    </Center>
  );
}

export function ErrorAlert({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : "Something went wrong";
  return (
    <Alert color="red" title="Error">
      {message}
    </Alert>
  );
}

export function notifyError(error: unknown) {
  const msg = error instanceof ApiError ? error.message : "Request failed";
  notifications.show({ color: "red", title: "Error", message: msg });
}

export function notifyOk(message: string) {
  notifications.show({ color: "green", message });
}

/** `<input type="datetime-local">` value -> ISO 8601 with timezone. */
export function localToIso(value: string): string {
  return new Date(value).toISOString();
}

export function isoToLocalInput(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatTs(ts: string | null | undefined): string {
  return ts ? new Date(ts).toLocaleString() : "—";
}
